import LogService from './log-service';

export const PERSISTENT_KEY_PREFIX = 'v3-f2882640';

class LocalStorageService {
  getItem(item, shouldWarn = true) {
    let result;
    try {
      result = window.localStorage.getItem(item);
    } catch (error) {
      if (shouldWarn) {
        LogService.logWarning(`error getting ${item} from local storage`, error);
      }
      LogService.logInfo(error);
    }
    try {
      result = JSON.parse(result);
    } catch (error) {
      LogService.logInfo(error);
    }
    return result;
  }

  setItem(item, value) {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
      window.localStorage.setItem(item, stringValue);
    } catch (error) {
      LogService.logWarning(`Unable to save ${item} to local storage.`, error);
    }
  }

  removeItem(item) {
    try {
      window.localStorage.removeItem(item);
    } catch (error) {
      LogService.logWarning(`Unable to remove ${item} from local storage.`, error);
    }
  }

  clearItemsWithPrefix(prefix) {
    try {
      let i = 0;
      while (i < window.localStorage.length) {
        const key = window.localStorage.key(i);
        if (key.startsWith(prefix)) {
          window.localStorage.removeItem(key);
        } else {
          i++;
        }
      }
    } catch (error) {
      LogService.logWarning(`Unable to clear prefix ${prefix} to local storage.`, error);
    }
  }

  clearItemsWithoutPrefix(prefix) {
    try {
      let i = 0;
      while (i < window.localStorage.length) {
        const key = window.localStorage.key(i);
        if (!key.startsWith(prefix)) {
          window.localStorage.removeItem(key);
        } else {
          i++;
        }
      }
    } catch (error) {
      LogService.logWarning(`Unable to clear key without prefix ${prefix} to local storage.`, error);
    }
  }

  clear() {
    try {
      this.clearItemsWithoutPrefix(PERSISTENT_KEY_PREFIX);
    } catch (error) {
      LogService.logWarning('Unable to clear local storage', error);
    }
  }
}

export default new LocalStorageService();
